export const getRequiredNotTextInputMessage = fieldName => `${fieldName} is not filled`;

export const getRequiredMessage = fieldName => `${fieldName} is required`;

export const getInvalidMessage = fieldName => `Please enter a valid ${fieldName}`;

export const getMinDateMessage = fieldName => `${fieldName} should not be less than 01/01/1900`;

export const getROInvalidMessage = "Only numbers without spaces are allowed";
export const getNotTrimmedMessage = fieldName => `${fieldName} should not have trailing spaces`;

export const nameInvalidMessage = "Please enter alphabets only";
